import { Backdrop, CircularProgress } from '@mui/material';
import refreshToken from 'api/auth/refreshToken';
import useAuth from 'auth/hook/useAuth';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

const PersistLogin = () => {
  const [loading, setLoading] = useState(true);
  const { auth, setAuth, persist } = useAuth();

  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        const response = await refreshToken();
        // console.log(data);
        setAuth(response.data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    !auth?.accessToken && persist ? verifyRefreshToken() : setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!persist) {
    return <Outlet />;
  } else if (loading) {
    return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  } else {
    return <Outlet />;
  }
};

export default PersistLogin;
